/**
 * todo
 * @class sgvizler.MESSAGES
 * @memberof sgvizler
 */
export var MESSAGES;
(function (MESSAGES) {
    MESSAGES[MESSAGES["ERROR_CHART_UNKNOWN"] = 0] = "ERROR_CHART_UNKNOWN";
    MESSAGES[MESSAGES["ERROR_CHART_PATTERN_OPTION_UNKNOWN"] = 1] = "ERROR_CHART_PATTERN_OPTION_UNKNOWN";
    MESSAGES[MESSAGES["ERROR_REQUEST"] = 2] = "ERROR_REQUEST";
    MESSAGES[MESSAGES["ERROR_CHART"] = 3] = "ERROR_CHART";
    MESSAGES[MESSAGES["ERROR_DEPENDENCIES"] = 4] = "ERROR_DEPENDENCIES";
    MESSAGES[MESSAGES["ERROR_ENDPOINT_FORGOT"] = 5] = "ERROR_ENDPOINT_FORGOT";
    MESSAGES[MESSAGES["ERROR_DATA_EMPTY"] = 6] = "ERROR_DATA_EMPTY";
    MESSAGES[MESSAGES["ERROR_DATA_NOROW"] = 7] = "ERROR_DATA_NOROW";
})(MESSAGES || (MESSAGES = {}));
/**
 *
 * @class sgvizler.Messages
 * @memberof sgvizler
 */
export class Messages {
    static get(id, args) {
        let message = '';
        switch (id) {
            case MESSAGES.ERROR_CHART_UNKNOWN:
                message = 'The chart $0 does not exist.';
                break;
            case MESSAGES.ERROR_CHART_PATTERN_OPTION_UNKNOWN:
                message = "The pattern of chart options is unknown : '$0'" +
                    "Use 'variable1=value1|variable1=value1' or for style 'width:100%;font:red;' or 'class1 class2'";
                break;
            case MESSAGES.ERROR_REQUEST:
                message = 'Sorry, the sparql server sent an error. </br> $0';
                break;
            case MESSAGES.ERROR_CHART:
                message = 'Sorry, the chart sent an error. </br> $0';
                break;
            case MESSAGES.ERROR_DEPENDENCIES:
                message = 'The chart dependencies sent an error. </br> $0';
                break;
            case MESSAGES.ERROR_ENDPOINT_FORGOT:
                message = 'The endpoint of Sparql service is forgotten (data-sgvizler-endpoint).';
                break;
            case MESSAGES.ERROR_DATA_EMPTY:
                message = 'The resquest sent null.';
                break;
            case MESSAGES.ERROR_DATA_NOROW:
                message = 'The resquest sent no row.';
                break;
        }
        if (args) {
            for (let i = 0, len = args.length; i < len; i++) { // tslint:disable-line
                message = message.replace('$' + i, args[i]);
            }
        }
        return message;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2d2aXpsZXIvTWVzc2FnZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUNILE1BQU0sQ0FBTixJQUFZLFFBU1g7QUFURCxXQUFZLFFBQVE7SUFDaEIscUVBQW1CLENBQUE7SUFDbkIsbUdBQWtDLENBQUE7SUFDbEMseURBQWEsQ0FBQTtJQUNiLHFEQUFXLENBQUE7SUFDWCxtRUFBa0IsQ0FBQTtJQUNsQix5RUFBcUIsQ0FBQTtJQUNyQiwrREFBZ0IsQ0FBQTtJQUNoQiwrREFBZ0IsQ0FBQTtBQUNwQixDQUFDLEVBVFcsUUFBUSxLQUFSLFFBQVEsUUFTbkI7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxPQUFPLFFBQVE7SUFDVixNQUFNLENBQUMsR0FBRyxDQUFFLEVBQVksRUFBQyxJQUFvQjtRQUNoRCxJQUFJLE9BQU8sR0FBRyxFQUFFLENBQUE7UUFDaEIsUUFBUSxFQUFFLEVBQUU7WUFDUixLQUFLLFFBQVEsQ0FBQyxtQkFBbUI7Z0JBQzdCLE9BQU8sR0FBRyw4QkFBOEIsQ0FBQTtnQkFDeEMsTUFBSztZQUNULEtBQUssUUFBUSxDQUFDLGtDQUFrQztnQkFDNUMsT0FBTyxHQUFHLGdEQUFnRDtvQkFDdEQsZ0dBQWdHLENBQUE7Z0JBQ3BHLE1BQUs7WUFDVCxLQUFLLFFBQVEsQ0FBQyxhQUFhO2dCQUN2QixPQUFPLEdBQUcsa0RBQWtELENBQUE7Z0JBQzVELE1BQUs7WUFDVCxLQUFLLFFBQVEsQ0FBQyxXQUFXO2dCQUNyQixPQUFPLEdBQUcsMENBQTBDLENBQUE7Z0JBQ3BELE1BQUs7WUFDVCxLQUFLLFFBQVEsQ0FBQyxrQkFBa0I7Z0JBQzVCLE9BQU8sR0FBRyxnREFBZ0QsQ0FBQTtnQkFDMUQsTUFBSztZQUNULEtBQUssUUFBUSxDQUFDLHFCQUFxQjtnQkFDL0IsT0FBTyxHQUFHLHVFQUF1RSxDQUFBO2dCQUNqRixNQUFLO1lBQ1QsS0FBSyxRQUFRLENBQUMsZ0JBQWdCO2dCQUMxQixPQUFPLEdBQUcseUJBQXlCLENBQUE7Z0JBQ25DLE1BQUs7WUFDVCxLQUFLLFFBQVEsQ0FBQyxnQkFBZ0I7Z0JBQzFCLE9BQU8sR0FBRywyQkFBMkIsQ0FBQTtnQkFDckMsTUFBSztTQUNaO1FBRUQsSUFBSSxJQUFJLEVBQUU7WUFDTixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxHQUFHLEdBQUcsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLEdBQUcsR0FBRyxFQUFFLENBQUMsRUFBRSxFQUFFLEVBQUUsc0JBQXNCO2dCQUNyRSxPQUFPLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxHQUFHLEdBQUcsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO2FBQzlDO1NBQ0o7UUFFRCxPQUFPLE9BQU8sQ0FBQTtJQUNsQixDQUFDO0NBQ0oifQ==